// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */
import 'alpinejs';

import cardSlider from '@/blocks/CardSlider.js';
import containedSlider from '@/blocks/ContainedCardSlider.js';
import videoPlayer from '@/blocks/VideoPlayer';

import messageHero from '@/modules/MessageHero';
import podcastHero from '@/modules/PodcastHero';
import header from '@/modules/Header';

export default {
    init() {
        cardSlider.init();
        containedSlider.init();
        videoPlayer.init();

        messageHero.init();
        podcastHero.init();
    },
    finalize() {}
};
